<template>
  <el-dialog title="修改密码" :visible.sync="visible">
    <el-form :model="seeker" ref="form" :rules="rules" :label-width="labelWidth">
      <el-form-item label="电子邮箱" prop="email">
        <el-input v-model="seeker.email" :readonly="true"></el-input>
      </el-form-item>
      <el-form-item label="旧密码" prop="oldPassword">
        <el-input v-model="seeker.oldPassword" type="password" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input v-model="seeker.newPassword" type="password" auto-complete="off"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="seeker.confirmPassword" type="password" auto-complete="off"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
    <el-button @click="onClose">取消</el-button>
    <el-button type="primary" :loading="loading" @click.native.prevent="handleSubmit('form')">确定</el-button>
  </span>
  </el-dialog>
</template>

<script>
import {putAction} from "@/api/manage"

export default {
  data() {
    return {
      visible: false,
      loading: false,
      seeker: {},
      rules: {
        oldPassword: [{required: true, message: '请输入旧密码', trigger: 'blur'}],
        newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'}],
        confirmPassword: [{validator: this.confirmValid, trigger: 'blur'}]
      },
      url: '/seeker/resetPassword',
      labelWidth: '120px'
    }
  },
  methods: {
    show(email, id) {
      this.seeker.email = email
      this.seeker.id = id
      this.visible = true
    },
    confirmValid(rule, value, callback) {
      let newPassword = this.seeker.newPassword
      if (value && value !== newPassword) {
        callback('两次输入的密码不一样！')
      } else {
        callback()
      }
    },
    handleSubmit(formData) {
      let _this = this
      _this.$refs[formData].validate((valid) => {
        if (valid) {
          _this.loading = true
          putAction(_this.url, _this.seeker).then(res => {
            if (res.success) {
              _this.onClose()
            } else {
              _this.$message.error(res.message)
            }
          }).finally(() => {
            _this.loading = false
          })
        }
      })
    },
    onClose() {
      this.visible = false
      this.seeker = {}
    }
  }
}
</script>

<style>
</style>
